import React from "react";
import { createPortal } from "react-dom";
import CheckIcon from "@mui/icons-material/Check";
import {
  SheetBackdrop,
  Sheet,
  SheetTitle,
  SheetOptions,
  SheetOption,
} from "./styles";
import { SelectSheetProps } from "./types";

export const SelectSheet: React.FC<SelectSheetProps> = ({
  isOpen,
  title,
  options,
  selectedValue,
  onSelect,
  onClose,
}) => {
  if (!isOpen) {
    return null;
  }

  const stopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  return createPortal(
    <SheetBackdrop onClick={onClose}>
      <Sheet onClick={stopPropagation}>
        <SheetTitle>{title}</SheetTitle>
        <SheetOptions>
          {options.map((option) => {
            const isSelected = option.value === selectedValue;
            return (
              <SheetOption
                key={option.value}
                type="button"
                $selected={isSelected}
                onClick={() => onSelect(option)}
              >
                {option.label}
                {isSelected ? (
                  <CheckIcon sx={{ color: "var(--color-primary)" }} />
                ) : null}
              </SheetOption>
            );
          })}
        </SheetOptions>
      </Sheet>
    </SheetBackdrop>,
    document.body,
  );
};
